module.exports = __webpack_public_path__ + "components/weather-icon/static/daypartcloud@2-3875c7ba11f9d64538fd100ebb75fa54.png";